export default __webpack_public_path__ + "static/media/sqField2.1b171215.png";